import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { GRAPH_CONSTANTS } from './constants';

export const saveCanvas = (fileName: string, canvasId: string = GRAPH_CONSTANTS.CANVAS_ID): void => {
	const canvasSave = document.getElementById(canvasId) as HTMLCanvasElement | null;
	if (!canvasSave) return;

	canvasSave.toBlob((blob) => {
		if (blob) {
			saveAs(blob, fileName);
		}
	});
};

export const generateFilename = (clientName: string, itemName: string): string => {
	const timestamp = dayjs().format(GRAPH_CONSTANTS.PDF_DATETIME_FORMAT);

	return `${timestamp}-${clientName}-${itemName}`;
};

export const calculateAverage = (data: Array<{ x: string; y: number }>): number => {
	if (!data || data.length === 0) return 0;
	const total = data.reduce((sum, item) => sum + item.y, 0);

	return total / data.length;
};

export const filterAnnotationsByDate = <T extends { date: string }>(annotations: T[], startDate: string): T[] => {
	if (!annotations) return [];

	return annotations.filter((annotation) => new Date(annotation.date) >= new Date(startDate));
};
